import { call, put, takeEvery } from 'redux-saga/effects';
import { CartsActionKeys, FetchCart, ICart } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { uiActionCreators } from '../../ui';
import { cartsActionCreators } from '../cartsActionCreators';
import * as api from '../cartsApi';

function* fetchCartSaga(action: FetchCart) {
  yield put(uiActionCreators.toggleLoading('newDealerRequest'));
  const response: IApiExecuteRespone<ICart> = yield call(api.fetchCart, action.payload.cartId);

  if (!response.requestFailed && response.value) {
    yield put(cartsActionCreators.setCart(response.value));
  } else {
    // TODO - show error message
  }

  yield put(uiActionCreators.toggleLoading('newDealerRequest'));
}

export function* watchFetchCart() {
  yield takeEvery(CartsActionKeys.FETCH_CART, fetchCartSaga);
}
